import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { Drawer, Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { AsideBattleList } from '../Aside/AsideBattleList';
import { AsideChallengesList } from '../Aside/AsideChallengesList';
import { AsideChat } from '../Aside/AsideChat';
import { AsideLogin } from '../Aside/AsideLogin';
import { AsideTabControl } from '../Aside/AsideTabControl';
import classes from './ChatPopup.module.css';
import tabStyle from './Header.module.css';
export type ChatPopupProps = {
  opened: boolean;
  close: () => void;
};
export const ChatPopup: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Drawer opened={openModal === MODAL.CHAT} onClose={() => setOpenModal(null)} offset={isMobile ? 0 : 8} radius="md" position={isMobile ? 'bottom' : 'right'} size={isMobile ? '79%' : 'sm'} bg="var(--navbar-bg-color)" removeScrollProps={{
    allowPinchZoom: true
  }} overlayProps={{
    backgroundOpacity: 0.6,
    blur: 3,
    visibleFrom: 'sm'
  }} closeButtonProps={{
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} withCloseButton={!isMobile} style={{
    overflow: 'hidden'
  }} classNames={classes} transitionProps={{
    transition: 'fade-left',
    duration: 150,
    timingFunction: 'linear'
  }}>
      <Tabs variant="pills" defaultValue="chat" classNames={{
      tab: tabStyle.tab
    }}>
        <AsideTabControl />

        <Tabs.Panel value="chat">
          <AsideChat />
          <AsideLogin />
        </Tabs.Panel>

        <Tabs.Panel value="battle">
          <AsideBattleList />
        </Tabs.Panel>

        <Tabs.Panel value="challenges">
          <AsideChallengesList />
        </Tabs.Panel>
      </Tabs>
    </Drawer>;
};